import '../../style/index.less';
import './index.less';
// style dependencies
import '../../skeleton/style';
import '../../tabs/style';
